module.exports = __webpack_public_path__ + "static/media/paper-plane-solid.dd3aa227.svg";